import { Combobox as ComboboxPrimitive } from '@base-ui/react/combobox';

import CheckIcon from '@/assets/svg/bx-check.svg?react';
import { cn } from '@/lib/utils';

import {
  pickerOptionSizeClasses,
  pickerTriggerIconSizeClasses,
  type PickerSize,
} from '../pickerPrimitiveStyles';
import { useComboboxContext } from './ComboboxContext';

export type ComboboxItemProps = ComboboxPrimitive.Item.Props & {
  size?: PickerSize;
};

const ComboboxItem = ({ className, children, ...props }: ComboboxItemProps) => {
  const { size } = useComboboxContext();

  return (
    <ComboboxPrimitive.Item
      data-slot="combobox-item"
      className={cn(
        'group relative flex w-full cursor-pointer items-center gap-1.5 rounded-md outline-hidden select-none',
        'aria-selected:font-semibold data-highlighted:not-data-disabled:bg-green-400',
        'pr-8 pl-2.25',
        'not-data-[variant=destructive]:aria-selected:**:font-semibold',
        'data-disabled:cursor-not-allowed data-disabled:bg-gray-100 data-disabled:text-gray-500',
        '[&_svg]:pointer-events-none [&_svg]:shrink-0',
        pickerOptionSizeClasses[size],
        pickerTriggerIconSizeClasses[size],
        className,
      )}
      {...props}
    >
      {children}
      <ComboboxPrimitive.ItemIndicator
        render={
          <span className="pointer-events-none absolute right-1 flex items-center justify-center">
            <CheckIcon className="pointer-events-none" />
          </span>
        }
      />
    </ComboboxPrimitive.Item>
  );
};

export default ComboboxItem;
